import React, { useState } from "react";
import { Grid, TableCell, TableRow } from "@mui/material";
import TableDesign from "../../../../components/common/table/TableDesign";
import dayjs from "dayjs";
import { getStorageLogs } from "../storageStaticData";

interface StorageLogListProps {
  leadId: string | null;
}

const StorageLogList: React.FC<StorageLogListProps> = ({ leadId }) => {
  const logs = getStorageLogs(leadId);

  const [filterOption, setFilterOption] = useState({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  const pagination = {
    totalItems: logs.length,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false,
  };

  const tableHeadings: {
    label: string;
    align: "center" | "left" | "right" | undefined;
  }[] = [
    { label: "User", align: "center" },
    { label: "Created On", align: "left" },
    { label: "Time", align: "left" },
    { label: "Action", align: "left" },
  ];

  return (
    <Grid
      container
      spacing={1}
      sx={{ marginLeft: "0px", marginTop: "0px" }}
    >
      <Grid
        item
        md={12}
        xs={12}
        sx={{ padding: "0px !important", border: "1px solid #d1cfcf" }}
      >
        <TableDesign
          tableHeadColor="#e5f4f1"
          tableHeadings={tableHeadings}
          pagination={pagination}
          isLoader={false}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        >
          {logs.length > 0 ? (
            logs.map((val: any, idx: number) => (
              <TableRow
                key={idx}
                sx={{
                  backgroundColor: idx % 2 === 1 ? "#eeecf0" : "none",
                }}
              >
                <TableCell align="center" style={{ padding: "0px" }}>
                  {val?.actor_name}
                </TableCell>
                <TableCell>
                  {dayjs(val?.created_at).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell>
                  {dayjs(val?.created_at).format("HH:mm")}
                </TableCell>
                <TableCell>{val?.action}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5}>No Data Found!</TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Grid>
    </Grid>
  );
};

export default StorageLogList;
